import React from 'react'
import { useTheme } from 'styled-components'
import { useMediaQuery } from '../../core/application/hooks'
import { deviceSizes } from '../../core/application/theme/breakpoints'


const CloseIcon: React.FC = () => {

    const isMobile = useMediaQuery(parseInt(deviceSizes.tablet))
    const { color } = useTheme()
    const fillColor = isMobile ? color.black : color.iconGray

    return <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 1.45455L14.5455 0L8 6.54545L1.45455 0L1.96174e-06 1.45455L6.54545 8L0 14.5455L1.45455 16L8 9.45455L14.5455 16L16 14.5455L9.45454 8L16 1.45455Z" fill={fillColor}/>
    </svg>
}

export default CloseIcon
